import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { IntlProvider } from 'react-intl';
import { useLocale } from '../contexts/LocaleProvider';
import DebouncedLoader from './common/DebouncedLoader';
import { useAboutInvestorRelationsContent } from '../graphql/pimcore/modules/siteContent/hooks/useAboutInvestorRelationsContent';
import InvestorRelationHome from './investorPage/investorRelationHome';
import { PrefilteredResourceLibraryItemsProvider } from '../graphql/pimcore/modules/resourceLibrary/contexts/PrefilteredResourceLibraryItemsProvider';

const InvestorRelationsPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();
    const { loading, error, contentTree } = useAboutInvestorRelationsContent();
    if (error && !loading) {
        return <div className="mid-width">Error: {error.message}</div>;
    }

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <PrefilteredResourceLibraryItemsProvider
                    initialFilters={{ resourceTypeKeys: ['Financial'] }}
                >
                    <Box width="100%" component="main" sx={{ padding: 0, flexGrow: 0, p: 0 }}>
                        <InvestorRelationHome cmsContent={contentTree} />
                    </Box>
                </PrefilteredResourceLibraryItemsProvider>
            </IntlProvider>
        </DebouncedLoader>
    );
};

export default InvestorRelationsPage;
